// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".half-charts[data-v-cbb95082]{display:flex;flex-wrap:wrap}.half-charts>div[data-v-cbb95082]{flex:1 0 50%;min-width:400px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
